// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"d59397025fc5a63dcf46","303":"b69a55fa0a041dbd9b4c","495":"33b011244b9e8460eb2a"}[chunkId] + ".js";
};